import { render } from "./DocumentRowActions.vue?vue&type=template&id=1ed1a9a0"
import script from "./DocumentRowActions.vue?vue&type=script&lang=js"
export * from "./DocumentRowActions.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__